import { Empty } from "antd";
import { useMemo } from "react";
import { PageHeader } from "../components/PageHeader";
import { NavCards } from "../components/NavCards";
import { useUser } from "../context/UserContext";
import { modulePath, visibleModules } from "../helpers/nav";

// The landing page: every module the user can reach, as a card. Modules with more than
// one page open a hub (/m/:key); the rest link straight through.
export default function HomePage() {
  const { user } = useUser();
  const modules = useMemo(() => visibleModules(user), [user]);

  return (
    <div>
      <PageHeader title="Home" subtitle={user ? `Signed in as ${user.name}` : undefined} />
      {modules.length === 0 ? (
        <Empty description="No modules available — ask an administrator to assign you a role." />
      ) : (
        <NavCards cards={modules.map((m) => ({ key: m.key, label: m.label, path: modulePath(m), description: m.description, icon: m.icon }))} />
      )}
    </div>
  );
}
